/**
 * @generated SignedSource<<72bd249e4f2da0038fd65ebc3687c2d2>>
 * @relayHash f6c6be2638bd276eed3ee9467a28cb6b
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/564.0.0-2026-06-16T17:18:39.177Z/LikeItemMutation

import { ConcreteRequest } from 'relay-runtime';
export type NftItemLikeAction = "ADD" | "REMOVE" | "%future added value";
export type NftItemLikeInput = {
  action: NftItemLikeAction;
  clientMutationId?: string | null;
  itemId: string;
  userId: string;
};
export type LikeItemMutation$variables = {
  input: NftItemLikeInput;
  itemId: string;
  userId: string;
};
export type LikeItemMutation$data = {
  readonly nftItemLike: {
    readonly nftItem: {
      readonly id: string;
      readonly likes: {
        readonly isLikedByUser: boolean | null;
        readonly likeCount: number | null;
      } | null;
    } | null;
    readonly nftItemUserLike: {
      readonly id: string;
      readonly isLiked: boolean | null;
      readonly nftId: string | null;
    } | null;
    readonly viewer: {
      readonly id: string;
      readonly isNftItemLikedByUser: boolean | null;
    };
  } | null;
};
export type LikeItemMutation$rawResponse = {
  readonly nftItemLike: {
    readonly nftItem: {
      readonly id: string;
      readonly likes: {
        readonly isLikedByUser: boolean | null;
        readonly likeCount: number | null;
      } | null;
    } | null;
    readonly nftItemUserLike: {
      readonly id: string;
      readonly isLiked: boolean | null;
      readonly nftId: string | null;
    } | null;
    readonly viewer: {
      readonly id: string;
      readonly isNftItemLikedByUser: boolean | null;
    };
  } | null;
};
export type LikeItemMutation = {
  rawResponse: LikeItemMutation$rawResponse;
  response: LikeItemMutation$data;
  variables: LikeItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "NftItemLikePayload",
    "kind": "LinkedField",
    "name": "nftItemLike",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NftItem",
        "kind": "LinkedField",
        "name": "nftItem",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NftItemLikes",
            "kind": "LinkedField",
            "name": "likes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "likeCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v4/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "isLikedByUser",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NftItemUserLike",
        "kind": "LinkedField",
        "name": "nftItemUserLike",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nftId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isLiked",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "nftId",
                "variableName": "itemId"
              },
              (v4/*: any*/)
            ],
            "kind": "ScalarField",
            "name": "isNftItemLikedByUser",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "LikeItemMutation",
    "selections": (v5/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "LikeItemMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "id": "app-buyer-nft/564.0.0-2026-06-16T17:18:39.177Z/LikeItemMutation",
    "metadata": {},
    "name": "LikeItemMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "32be56512da482be1dd893aab49cbf26";

export default node;
